var render = function render(){var _vm=this,_c=_vm._self._c;return _c('A2PRegistrationWizard',{attrs:{"target-site-i-d":_vm.targetSiteID,"target-site-name":_vm.targetSiteName,"target-site-country":_vm.targetSiteCountry}})
}
var staticRenderFns = []

export { render, staticRenderFns }